import { Component, OnInit } from '@angular/core';
import {Contract} from "../../../classes/contract";
import {ContractService} from "../../../services/contract";
import {switchMap} from "rxjs/operators";
import {from} from "rxjs";
import {InspectionService} from "../../../services/inspection";

@Component({
  selector: 'app-inspection',
  templateUrl: './inspection-import.component.html',
  styleUrls: ['./inspection-import.component.css']
})
export class InspectionImportComponent implements OnInit {

  contracts: Array<Contract> = [];
  contractSelected: number | null = null;
  fileName = '';
  fileData = new FormData();
  inspectionImportResult: boolean | undefined = undefined;

  constructor(private contractService: ContractService,
              private inspectionService: InspectionService) { }

  ngOnInit(): void {
    this.contractService.getAll()
        .pipe(
            switchMap((contractsData: any) => from(contractsData))
        )
        .subscribe({
          next: (contract: any) => {
            this.contracts.push(contract);
          },
          error: e => {
            console.log('Error: ' + e);
          }
        });
  }

  onFileSelected(event: any) {
    const file: File = event.target.files[0];
    if (file) {
      this.fileName = file.name;
      this.fileData.set('inspectionsFile', file);
    }
  }

  onSubmit() {
    this.fileData.set('contract', (this.contractSelected || '').toString());
    this.inspectionService.upload(this.fileData)
        .subscribe({
          next: () => {
            this.inspectionImportResult = true;
          },
          error: e => {
            this.inspectionImportResult = false;
            console.log(e);
          }
        });
  }

}
